import React, {Component} from 'react';
import PropTypes from 'prop-types';
import { reduxForm } from 'redux-form';
import asyncValidate from './asyncValidate';
import FormFieldsTabPrograms from '../../form-modules-programs-tab/tab-programs';
class EditViewClientTabPrograms extends Component {
  render() {
    return (
      <div>
        <FormFieldsTabPrograms
          {...this.props}
          locked={this.props.locked}
          programOptionsMode={1}

          allowChangeProgram={this.props.allowChangeProgram}
          handleSubmitChangeProgram={this.props.handleSubmitChangeProgram}

          programSelected={this.props.programSelected}

          programsList={this.props.programsList}
          bopinstitutionsList={this.props.bopinstitutionsList}
          gangaffiliationsList={this.props.gangaffiliationsList}
        />
      </div>
    );
  }
}
EditViewClientTabPrograms.propTypes = {
  /*** fix make required */
  locked: PropTypes.bool,
  allowChangeProgram: PropTypes.bool,
  programSelected: PropTypes.string,
  /*** fix make required */
  programsList: PropTypes.array,
  bopinstitutionsList: PropTypes.array,
  gangaffiliationsList: PropTypes.array,
  /*** function provided by parent */
  handleSubmitChangeProgram: PropTypes.func,
}
EditViewClientTabPrograms = reduxForm({
  form: 'ClientEditForm', // a unique name for this form
  asyncValidate,
  destroyOnUnmount: false, // <------ preserve form data
  forceUnregisterOnUnmount: true, // <------ unregister fields on unmount
})(EditViewClientTabPrograms);
export default EditViewClientTabPrograms;